const CANCEL_DROP_MODAL_DESCRIPTION_MODAL_PROPS = {
  'data-testid': 'proof-income-landing-modal-feature-01',
};

const CURRENCY_STYLE = 'currency';

export { CANCEL_DROP_MODAL_DESCRIPTION_MODAL_PROPS, CURRENCY_STYLE };
